import { ref, onMounted, onUnmounted, watch } from 'vue';
import { useAuthStore } from '@/store/auth';

export function useSession() {
  const authStore = useAuthStore();
  const idleTimer = ref<number | null>(null);
  const ONE_DAY = 24 * 60 * 60 * 1000;
  const timeoutDuration = 7 * ONE_DAY;

  const resetTimer = () => { 
    if (idleTimer.value) {
      clearTimeout(idleTimer.value);
    }
    
    // Only set timer if user is logged in
    if (authStore.token) { 
      idleTimer.value = window.setTimeout(() => {  
        authStore.logout(true); // Pass true to show "Session Expired" notification
      }, timeoutDuration);
    }
 else {
      console.log('ℹ️ No token found, timer not set.');
    }
  };

  // Watch for token changes to start/stop tracking
  watch(() => authStore.token, (newToken: string | null) => { 
    resetTimer();
  });

  const activityEvents = [
    'mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'
  ];

  const handleActivity = () => {
    resetTimer();
  };

  onMounted(() => {
    activityEvents.forEach(event => {
      window.addEventListener(event, handleActivity);
    });
    resetTimer();
  });

  onUnmounted(() => {
    activityEvents.forEach(event => {
      window.removeEventListener(event, handleActivity);
    });
    if (idleTimer.value) {
      clearTimeout(idleTimer.value);
    }
  });

  return {
    resetTimer
  };
}
